import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import FormControl from "@material-ui/core/FormControl/FormControl";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import {useDispatch, useSelector} from "react-redux";

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  formControl: {
    marginRight: theme.spacing(1),
    minWidth: theme.spacing(1) * 10,
    width: '100%'
  },
  relative: {
    position: 'relative'
  },
  textControl : {
    paddingTop: 0,
    paddingBottom: 5,
  },
  switchControl : {
    width: 58,
    height: 38,
    display: 'inline-flex',
    padding: 12,
    zIndex: 0,
    overflow: 'hidden',
    position: 'relative',
    boxSizing: 'border-box',
    flexShrink: 0,
    verticalAlign: 'middle',
    paddingBottom: 5,
  },
  tableTextField: {
    width: '100%',
    '& fieldset': {
      borderRadius: '0'
    },
    '& input': {
      padding: '20px'
    }
  },
  row: {
    marginBottom: theme.spacing(1),
  }
}));

const DiarioProducaoDialog = ({
                              isOpen,
                              isAddNewRecord,
                              selectedRow,
                                  cbDialog

}) => {

  const classes = useStyles();
  const [addNewRecord, setaddNewRecord] = React.useState(isAddNewRecord ? isAddNewRecord : false);
  const [open, setOpen] = React.useState(isOpen);
  const [osCodigo, setOrderId] = React.useState(null);
  const [posicao, setPosicao] = React.useState(null);
  const [marca, setMarca] = React.useState(null);
  const [modelo, setModelo] = React.useState(null);
  const [banda, setBanda] = React.useState(null);
  const [medida, setMedida] = React.useState(null);
  const [descricao, setDescricao] = React.useState(null);
  const [dot, setDot] = React.useState(null);
  const [marcaFogo, setMarcaFogo] = React.useState(null);
  const dispatch = useDispatch();
  let timeout = null;



  useEffect(() => {


  }, []);

  const handleClose = () => {
      cbDialog(false);
  };

  const resetNewForm = () => {
      setPosicao('');
      setOrderId('');

      setDescricao('');


      setModelo('');
      setMarca(null);
      setBanda('');
      setMedida('');
      setDot('');
      setMarcaFogo('');
  };

  const resetForm = () => {

    setDescricao('');

    setMarcaFogo('');
    setDot('');


  };





  // botao Novo
    const handleSaveNew = async() => {

        setOrderId('');
        resetNewForm();
        cbDialog(false);
    }


    const handleSave = event => {
        console.log("botaoSave", osCodigo, modelo, medida, banda);

      // setOrderId('');
      // resetNewForm();
  }


  const handleChange =  event => {
   //setReprocesso(event.target.checked);
  };

  const onOrderIdChanged = (event) => {
    const orderID = event.target.value;
    setOrderId(orderID);
    resetForm();
    clearTimeout(timeout);
    timeout = setTimeout(event => {
        //dispatch(getServiceOrderDetail(orderID));
    }, 2000)
  };


  const mId = marca? (marca.id? marca.id : '') : '';

  return (
    <div>
      <Dialog fullWidth maxWidth={'md'} scroll="body" open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Diário de Produção - EM DESENVOLVIMENTO</DialogTitle>
        <DialogContent>
          <Grid item xs={12} container spacing={3}>

            <Grid item xs={12} md={12}  lg={12} xl={12} container>

              <Grid item xs={12} md={12} lg={12} xl={12}  className={classes.row} container>
                <Grid item xs={12} md={12}  lg={12} xl={12} container>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="order-label-placeholder" className={classes.relative}>
                      Diário de Produção
                    </InputLabel>
                    <TextField
                      autoFocus
                      id="order"
                      label=""
                      type="text"
                      onChange={onOrderIdChanged}
                      value={osCodigo}
                      className={classes.textControl}
                    />
                  </FormControl>
                </Grid>
              </Grid>


              <Grid item xs={12} md={12} lg={12} className={classes.row} container>


                <Grid item xs={12} md={12} lg={12} className={classes.row} container>

                    <Grid item xs={12} md={3}  lg={3} container>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink htmlFor="dot" className={classes.relative}>
                                Pneus
                            </InputLabel>
                            <TextField
                                id="pneus"
                                label=""
                                type="text"
                                className={classes.textControl}
                                readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}
                                value={dot}
                                onChange={e=> setDot(e.target.value)}
                            />
                            {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}  lg={3} container>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink htmlFor="marcaFogo" className={classes.relative}>
                                Matéria Prima
                            </InputLabel>
                            <TextField
                                id="materiaPrima"
                                label=""
                                type="text"
                                className={classes.textControl}
                                readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}
                                value={marcaFogo}
                                onChange={e=> setMarcaFogo(e.target.value)}
                            />
                            {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={3}  lg={3} container>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink htmlFor="marcaFogo" className={classes.relative}>
                                Produção
                            </InputLabel>
                            <TextField
                                id="producao"
                                label=""
                                type="text"
                                className={classes.textControl}
                                readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}
                                value={marcaFogo}
                                onChange={e=> setMarcaFogo(e.target.value)}
                            />
                            {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                        </FormControl>
                    </Grid>






              <Grid item xs={12} md={12} lg={12} className={classes.row} container>



                <Grid item xs={12} md={6}  lg={8} container>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="descricao" className={classes.relative}>
                      descricao
                    </InputLabel>
                    <TextField
                      id="descricao"
                      label=""
                      type="text"
                      className={classes.textControl}
                      value={descricao}
                      readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}
                      onChange={e => setDescricao(e.target.value)}
                    />
                    {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                  </FormControl>
                </Grid>
              </Grid>

            </Grid>
            </Grid>

            </Grid>
          </Grid>


        </DialogContent>
        <DialogActions>
          <Button onClick={handleSaveNew} color="default">
              Novo
          </Button>
          <Button onClick={handleClose} color="default">
            Cancelar
          </Button>
        </DialogActions>


      </Dialog>
    </div>
  );
}


export default (DiarioProducaoDialog)
